<template>
  <div class="">


    <div class="form-group d-flex justify-content-around" v-for="(propItem,key) in mainProp">
      <label for="exampleInputEmail1">propItem {{ key + 1 }}</label>
      <i @click="removeItem(key)" class="bi h4 bi-trash"></i>
      <i data-toggle="modal" :data-target="`#prop_config_${key}`" class="bi h4 bi-gear"></i>

      <!-- Modal -->
      <div class="modal fade" :id="`prop_config_${key}`" tabindex="-1" aria-labelledby="exampleModalLabel"
           aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">

              <div class="" v-for="(item,index) in propItem">

                <div class="form-group" v-if="propOptions(index) === false">
                  <label :for="`prop_item_${index}`">{{ index }}</label>
                  <textarea class="form-control" v-model="propItem[index]" :id="`prop_item_${index}`"/>
                </div>

                <div class="form-group" v-else>
                  <label :for="`prop_item_${index}`">{{ index }}</label>
                  <select class="form-control" v-model="propItem[index]">
                    <option v-for="pItem in propOptions(index)" :value="pItem">{{pItem}}</option>
                  </select>
<!--                  <textarea class="form-control"  :id="`prop_item_${index}`"/>-->
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

    </div>


    <div class="text-center">
      <div class="btn btn-success" @click="addNewItem">ساخت ایتم جدید</div>
    </div>


  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "StaticFormManager",
  props: {
    component: {},
    propKey: {}
  },
  computed: {
    formSampleData() {
      if (this.component.rawProps[this.propKey] == null) return {}
      return this.component.rawProps[this.propKey].formOptions.sample
    },
    mainProp() {
      if (this.component.rawProps[this.propKey] == null) return {}
      let data = this.component.props[this.propKey];
      let sample = this.reshapeSampleToKeyValue(this.formSampleData)
      data.forEach((item, index) => {
        data[index] = {...sample, ...item}
      })
      return data
    },

  },
  methods: {
    reshapeSampleToKeyValue(sample) {
      return Object.fromEntries(
          Object.entries(sample).map(([key, value]) => [key, value.value])
      )
    },
    addNewItem() {
      let sample = Object.assign({}, this.formSampleData)

      sample = this.reshapeSampleToKeyValue(sample)

      this.mainProp.push(sample)
    },
    removeItem(itemIndex) {
      if (confirm('آیا از حذف ایتم اطمینان دارید؟')) {
        this.mainProp.splice(itemIndex, 1)
      }
    },
    propOptions(item) {
      console.log(item)
      if (Object.keys(this.formSampleData[item]).indexOf('options') > -1) {
        return this.formSampleData[item].options
      }

      return false
    }
  },
  mounted() {

  }
})
</script>

<style scoped>

</style>